import React, {useEffect, useState} from 'react';
import {
    Grid,
    Box,
    Card,
    CardContent,
    Typography,
    TextField,
} from '@mui/material';
import axios from 'axios';
import './ObjectsGrid.css';
import {useLocation, useNavigate} from 'react-router-dom';
import {jwtDecode} from 'jwt-decode';
import {useTranslation} from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import {IoDocumentText} from 'react-icons/io5';
import PopupLogin from '../popuplogin/PopupLogin';
import EntitySelectorDialog from "./EntitySelectorDialog";

const ObjectsGrid = ({onClose}) => {
    const [items, setItems] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [showEntityDialog, setShowEntityDialog] = useState(false);
    const [popupItem, setPopupItem] = useState(null);
    const [selectedEntities, setSelectedEntities] = useState({entity: null, explanationEntity: null});
    const hasSecondStep = true;
    const navigate = useNavigate();
    const location = useLocation();
    const [roleId, setRoleId] = useState('');
    const {i18n} = useTranslation();

    useEffect(() => {
        const token = localStorage.getItem('jwtToken');
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId('');
            }
        }
    }, []);

    const togglePopup = () => setIsPopupOpen(!isPopupOpen);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetPermitTypeTree`);
                const data = response.data;
                const record = data.data.find(item => item.id === 40);
                if (record && record.childrenPermitTypes) {
                    const preferredOrder = ["მაღარო", "შახტი", "კარიერი"];
                    const sorted = [
                        ...record.childrenPermitTypes.filter(i => preferredOrder.includes(i.title))
                            .sort((a, b) => preferredOrder.indexOf(a.title) - preferredOrder.indexOf(b.title)),
                        ...record.childrenPermitTypes.filter(i => !preferredOrder.includes(i.title))
                    ];
                    setItems(sorted);
                }
                setIsLoading(false);
            } catch (error) {
            }
        };
        void fetchData();
    }, []);



    const onCardClick = (accordionItem) => {
        if (roleId !== "USER") {
            setPopupItem(accordionItem);
            setShowEntityDialog(true);
        } else if (!accordionItem.url && roleId !== "USER") {
            setIsPopupOpen(true);
        } else if (!accordionItem.url && roleId === "USER") {
            navigate(`/dashboard/newcase?id=${accordionItem.id}&parentId=${accordionItem.permitTypeId || ''}`);
        } else if (location.pathname === '/services') {
            navigate(`${accordionItem.url}?permiturl=${accordionItem.id}&parentId=${accordionItem.permitTypeId}`);
        } else if (location.pathname === '/dashboard/objectregistration') {
            navigate(`/dashboard/newcaseexpert?id=${accordionItem.id}&parentId=${accordionItem.permitTypeId || ''}`)
        } else {
            setPopupItem(accordionItem);
            setShowEntityDialog(true);
        }
    };


    return (
        <div style={{minHeight: '60vh', minWidth: '78%', backgroundColor: 'white', borderRadius: 60, padding: 30}}>
            {isLoading ? (
                <div style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
                    <IoDocumentText style={{fontSize: 80, marginTop: '20%', color: '1A9AEE'}}
                                    className={'pulse-element'}/>
                    <h1>გთხოვთ დაელოდოთ...</h1>
                    <p>მონაცემები იტვირთება!</p>
                </div>
            ) : (
                <div>
                    {location.pathname !== '/dashboard/objectregistration' && (
                        <CloseIcon
                            style={{position: 'absolute', top: 8, right: 13, cursor: 'pointer'}}
                            onClick={onClose}
                        />
                    )}
                    {location.pathname === '/dashboard/objectregistration' && (
                        <TextField
                            type="search"
                            label="ძიება"
                            variant="outlined"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            sx={{marginY: 1}}
                        />
                    )}
                    <Grid container spacing={2}>
                        {isPopupOpen && <PopupLogin isOpened={isPopupOpen} onClose={togglePopup}/>}
                        {items
                            .filter(item => item.title.toLowerCase().includes(searchTerm.toLowerCase()))
                            .map(item => (
                                <Grid item xs={12} sm={6} md={4} lg={4} key={item.id}>
                                    <Card
                                        onClick={() => onCardClick(item)}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            height: '100%',
                                            justifyContent: 'space-between',
                                            '&:hover': {boxShadow: 6},
                                        }}
                                    >
                                        <CardContent
                                            sx={{
                                                flexGrow: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                cursor: 'pointer',
                                            }}
                                        >
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    marginBottom: 2,
                                                    backgroundColor: '#EFEFEF',
                                                    height: 80,
                                                    width: 80,
                                                    borderRadius: 3,
                                                }}
                                            >
                                                {item.icon && (
                                                    <Box
                                                        component="img"
                                                        sx={{
                                                            height: 60,
                                                            width: 44,
                                                            objectFit: 'contain',
                                                        }}
                                                        src={item.icon}
                                                        alt={item.title}
                                                    />
                                                )}
                                            </Box>
                                            <Typography gutterBottom variant="h6" component="div"
                                                        sx={{textAlign: 'center'}}>
                                                {i18n.language === 'geo' ? item.title : item.titleEng || item.title}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                    </Grid>
                </div>
            )}

            <EntitySelectorDialog
                open={showEntityDialog}
                onClose={() => {
                    setShowEntityDialog(false);
                    setSelectedEntities({entity: null, explanationEntity: null});
                }}
                onSelect={(type, step) => {

                    if (!hasSecondStep) {
                        setSelectedEntities({entity: type, explanationEntity: null});
                        setShowEntityDialog(false);
                        navigate(`/dashboard/newcase?id=${popupItem.id}&parentId=${popupItem.permitTypeId || ''}&entity=${type}`);
                    } else if (step === 1) {
                        setSelectedEntities(prev => ({...prev, entity: type}));
                    } else {
                        setSelectedEntities(prev => {
                            const updated = {...prev, explanationEntity: type};
                            setShowEntityDialog(false);
                            navigate(`/dashboard/newcase?id=${popupItem.id}&parentId=${popupItem.permitTypeId || ''}&entity=${updated.entity}&explanationEntity=${updated.explanationEntity}`);
                            return updated;
                        });
                    }
                }}
                hasSecondStep={hasSecondStep}
            />
        </div>
    );
};

export default ObjectsGrid;
